document.addEventListener("DOMContentLoaded", () => {
  // const PUBLIC = '6e0b4a66c160f5ea07abaeecb87fc087';
  // const PRIVATE = '7b50b89a54f4cfdfd384387226f32d31';
  const form = document.querySelector('.form form')! as HTMLFormElement;
  const message = document.querySelector('.form .actions .message')! as HTMLDivElement;
  const inputs = document.querySelectorAll('.form form input, .form form textarea, .form form button')! as NodeListOf<HTMLInputElement>;
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    inputs.forEach(input => input.dataset.disabled = "true");
    message.classList.remove('error');
    message.classList.add('info');
    message.textContent = 'Sending message...';
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    fetch('https://submit-form.com/VtnRi4Vnd', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          console.log(data);
        });
        message.classList.remove('info');
        message.classList.add('success');
        message.textContent = 'Message sent successfully';
        inputs.forEach(input => input.disabled = true);
      } else {
        message.classList.remove('info');
        message.classList.add('error');
        message.textContent = 'Failed to send message';
        inputs.forEach(input => input.dataset.disabled = "false");
      }
    }).catch((error) => {
      message.classList.remove('info');
      message.classList.add('error');
      message.textContent = 'Try again later.';
      inputs.forEach(input => input.dataset.disabled = "false");
    });
  });
});